import React, { useState } from "react";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";
import { FaArrowCircleDown, FaAlignJustify } from "react-icons/fa";

import logo from "../../../Assets/Logo/favicon.png";
import ParticleEffectButton from "react-particle-effect-button";
const Navbar = () => {
  const [hide, setHide] = useState(false);
  const menus = (
    <>
      <li className="text-xl font-bold">
        <Link to="">Home</Link>
      </li>
      <li className="text-xl font-bold">
        <Link to="aboutMe">About Me</Link>
      </li>
      <li className="text-xl font-bold">
        <Link to="projects">Projects</Link>
      </li>
      <li className="text-xl font-bold">
        <Link to="blog">Blog</Link>
      </li>
      <li className="text-xl font-bold">
        <Link to="contactMe">Contact Me</Link>
      </li>
    </>
  );

  return (
    <div className=" bg-gradient-to-r from-gray-900 to-transparent">
      <div className="navbar   md:px-20 container mx-auto">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost btn-lg lg:hidden">
              <FaAlignJustify></FaAlignJustify>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52 "
            >
              {menus}
            </ul>
          </div>
          <Fade bottom className="w-24">
            <Link to="/">
              <img src={logo} className="w-24" alt="Website logo" />
            </Link>
          </Fade>
        </div>
        <div className="navbar-center hidden lg:flex">
          <Fade left>
            <ul className="menu menu-horizontal p-0">{menus}</ul>
          </Fade>
        </div>
        <div className="navbar-end">
          <Fade bottom>
            <ParticleEffectButton color="#00d4bd" hidden={hide} />

            <a
              onClick={() => setHide(!hide)}
              href="https://drive.google.com/uc?export=download&id=1YZWed5_79c-r9fQeCc2q1cFyw8zmCpbG"
              className="btn btn-sm btn-primary  mr-5 
text-white bg-teal-800 rounded border hover:bg-white hover:text-gray-900  font-bold"
            >
              <FaArrowCircleDown className="mr-1"></FaArrowCircleDown> Resume
            </a>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
